import * as App from '../../../../app';
import { cellByIndex, roundRect } from '../../../../lib/utils';
import { FIGURINES_WITH_STARS } from '../../../../app/const/features';
import { star } from '../../../../svg';
// TODO: const starImages = {'#f5e8b8': star.toImage('#f5e8b8')}
var starImg = star.toImage('#f5e8b8');
export function drawData(canvas, data, cellSize, gridSize, gridPos, drawBorder, alpha) {
    if (drawBorder === void 0) { drawBorder = false; }
    if (alpha === void 0) { alpha = 1; }
    var _a = App.themes.get(), name = _a.name, cell = _a.cell, cellShadow = _a.cellShadow, cellWithStar = _a.cellWithStar /*, star*/;
    canvas.ctx.globalAlpha = alpha;
    for (var i = 0; i < data.length; i++) {
        if (data[i].value || data[i].shadow) {
            var item = cellByIndex(i, gridSize);
            var x = item[0] * cellSize + gridPos.x;
            var y = item[1] * cellSize + gridPos.y;
            var d = data[i].highlighting ? 4 : 2;
            var wh = cellSize;
            var whd = wh - 2 * d;
            var isStar = FIGURINES_WITH_STARS && data[i].value === 2;
            var cellColor = isStar ? cellWithStar : cell;
            if (name === 'old-school') {
                if (data[i].value) {
                    canvas.fillRect(x, y, wh, wh, cellColor);
                    canvas.fillRect(x, y, wh, wh, 'rgba(255,255,255,0.5)');
                    var cellBorder = '#1e2941';
                    canvas.strokeRect(x, y, wh, wh, cellBorder, 2);
                    canvas.fillRect(x + d, y + d, whd, whd, cellColor);
                }
                else {
                    canvas.fillRect(x + d, y + d, whd, whd, cellShadow);
                }
            }
            else {
                var r = Math.ceil(wh * (name === 'default' ? 0.05 : 0.15));
                if (data[i].value) {
                    if (drawBorder) {
                        // roundRect(canvas, x, y, wh, wh, r, 'rgba(0,0,0,0.15)')
                        canvas.save();
                        canvas.ctx.shadowColor = 'rgba(0,0,0,0.15)';
                        canvas.ctx.shadowBlur = 1;
                        canvas.ctx.shadowOffsetX = 2;
                        canvas.ctx.shadowOffsetY = 2;
                        roundRect(canvas, x + 1, y + 1, wh - 2, wh - 2, r, cellColor);
                        canvas.restore();
                    }
                    else {
                        roundRect(canvas, x, y, wh - 1, wh - 1, r, cellColor);
                    }
                    if (data[i].highlighting) {
                        roundRect(canvas, x, y, wh, wh, r, 'rgba(0,0,0,0.15)');
                    }
                }
                else {
                    roundRect(canvas, x + d, y + d, whd, whd, r, cellShadow);
                }
            }
            // Звезды
            if (isStar) {
                if (starImg && starImg.complete) {
                    var swh = starImg.width;
                    var dwh = Math.ceil(wh / 3);
                    var k = 2;
                    canvas.drawImage(starImg, 0, 0, swh, swh, x + k, y + k, dwh, dwh);
                    canvas.drawImage(starImg, 0, 0, swh, swh, x + wh - dwh - k, y + wh - dwh - k, dwh, dwh);
                }
            }
        }
    }
    canvas.ctx.globalAlpha = 1;
}
